<template>
	<div class="update-back">
		<div class="banner" v-lazy:background-image="{ src:require('../updateImg/banner.png'), loading: require('../updateImg/yasuo.jpg') }">
      <div class="divContsBg"></div>
      <div class="conts">
        <slot name="navList"></slot>
        <div class="texts">
          <h1>{{backGroundCom.title}}</h1>
          <p>{{backGroundCom.title1}}</p>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
	export default {
		props: {
			backGroundCom: {
				readonly: true,
				require: true,
				default: () => {}
			}
		},
		data () {
			return {
			}
		}
	}
</script>

<style lang="scss" scoped>
	.update-back {
		.banner {
      width: 100%;
      height: 559px;
      overflow: hidden;
      position: relative;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .divContsBg {
        // background-color: black;
        position: absolute;
        width: 100%;
        height: 81px;
        top: 0;
        // opacity: 0.11;
      }
      .conts {
        width: 1200px;
        margin: 0 auto;
        position: relative;
      }
      .texts {
        padding-top: 53px;
        h1 {
          font-size: 45px;
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
          text-align: left;
          color: #ffffff;
          font-weight: 400;
          line-height: 60px;
          letter-spacing: 3px;
          height: 69px;
          color: rgba(255, 255, 255, 1);
          margin-top: 80px;
          span {
            font-size: 60px;
          }
        }
        p {
          height: 71px;
          font-size: 24px;
          font-weight: 400;
          opacity: .8;
          color: #fff;
          line-height: 40px;
          margin-top: 10px;
          overflow: hidden;
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
        }
      }
    }
	}
</style>